<template>
    <div>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <v-card width="100%">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Pre solicitud</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">
                                    <vs-list justify="center">
                                        <label class="typo__label" style="text-align: center;">Proveedor:</label>
                                        <multiselect placeholder="Seleccione un valor"
                                                     :options="obtenerproveedor"
                                                     v-model="proveedor"
                                                     label="prnombre" track-by="prclave"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     :disabled="disabled"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor" @input="CuentaProveedor()">
                                        </multiselect>
                                        <span style="color: red;" v-show="validaproveedor">Selección requerida</span>
                                        <br />
                                        <div v-if="proveedor.prmatriz == ''" class="teal lighten-1 text-center">
                                            <span class="white--text">Proveedor matriz</span>
                                        </div>
                                        <div v-if="proveedor.prmatriz != ''" class="teal lighten-3 text-center">
                                            <span class="white--text">Proveedor con matriz</span>
                                        </div>
                                    </vs-list>
                                    <vs-list justify="center">
                                        <label class="typo__label" style="text-align: center;">Centro de Costo:</label>
                                        <multiselect placeholder="Seleccione un valor"
                                                     :options="obtenercentrocosto"
                                                     v-model="centrocosto"
                                                     label="ccsubcentro" track-by="ccclave"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     :disabled="disabled"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor">
                                        </multiselect>
                                        <span style="color: red;" v-show="validacentrocosto">Selección requerida</span>
                                    </vs-list>
                                    <vs-list justify="center">
                                        <label class="typo__label" style="text-align: center;">Concepto:</label>
                                        <v-text-field outlined
                                                      dense
                                                      maxlength="59"
                                                      :disabled="disabled"
                                                      :rules="[v =>
                                            !!v || 'Campo requerido',
                                            v => {
                                            if (v == null) {
                                            return true
                                            }
                                            else {
                                            if (v.length  < 10) {
                                            return 'Minino 10 caracteres'
                                            }
                                            else
                                            return true
                                            }
                                            }]"
                                            v-model="concepto">
                                        </v-text-field>
                                    </vs-list>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4" offset-md="2">
                                    <vs-list>
                                        <label class="typo__label" style="text-align: center;">Nivel 1:</label>
                                        <multiselect placeholder="Seleccione un valor" :options="nivel1"
                                                     label="gtnivel1" track-by="gtcv1" v-model="mnivel1"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     :allow-empty="false"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor" @input="addnivel1()">
                                        </multiselect>
                                    </vs-list>
                                    <vs-list>
                                        <label class="typo__label" style="text-align: center;">Nivel 2:</label>
                                        <multiselect placeholder="Seleccione un valor" :options="nivel2"
                                                     label="gtnivel2" track-by="gtcv2" v-model="mnivel2"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     :allow-empty="false"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor" @input="addnivel2()">
                                        </multiselect>

                                    </vs-list>
                                    <vs-list>
                                        <label class="typo__label" style="text-align: center;">Nivel 3:</label>
                                        <multiselect placeholder="Seleccione un valor" :options="nivel3" v-model="mnivel3"
                                                     label="gtnivel3" track-by="gtcv3"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     :allow-empty="false"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor" @input="addnivel3()">
                                        </multiselect>
                                    </vs-list>
                                    <vs-list>
                                        <label class="typo__label" style="text-align: center;">Nivel 4:</label>
                                        <multiselect placeholder="Seleccione un valor" :options="nivel4" v-model="mnivel4"
                                                     label="gtnivel4" track-by="gtcv4"
                                                     :allow-empty="false"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor" @input="addnivel4()">
                                        </multiselect>
                                    </vs-list>
                                    <vs-list>
                                        <label class="typo__label" style="text-align: center;">Nivel 5:</label>
                                        <multiselect placeholder="Seleccione un valor" :options="nivel5" v-model="mnivel5"
                                                     label="gtnivel5" track-by="gtcv5"
                                                     :allow-empty="false"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor">
                                        </multiselect>
                                    </vs-list>
                                    <span style="color: red;" v-show="validanivel">Selección requerida</span>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <vs-list justify="center">
                                        <label class="typo__label" style="text-align: center;">Monto:</label>
                                        <v-text-field outlined
                                                      dense
                                                      prepend-inner-icon="mdi-currency-usd"
                                                      @keypress="filter($event)"
                                                      @focus="Quitacero()"
                                                      v-model="monto">
                                        </v-text-field>
                                        <span style="color: red;" v-show="validamonto">{{textomonto}}</span>
                                    </vs-list>
                                    <v-row justify="center" class="mb-8">
                                        <v-btn class="ma-2"
                                               @click="Agregar()"
                                               :disabled="habilitar"
                                               color="primary">
                                            Agregar
                                        </v-btn>

                                    </v-row>
                                    <span style="color: red;" v-show="validapartida">Debe tener al menos una partida</span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">
                                    <v-data-table :headers="header"
                                                  hide-default-footer
                                                  no-data-text="No hay datos disponibles"
                                                  :items="partidas">
                                        <template v-slot:item.actions="{ item }">
                                            <v-btn color="error"
                                                   v-on:click="Eliminar(item);"
                                                   small
                                                   fab
                                                   dark>
                                                <v-icon>
                                                    mdi-trash-can-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <template v-slot:body.append>
                                            <tr>
                                                <td></td>
                                                <td>
                                                    {{total}}
                                                </td>
                                                <td></td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">
                                    <vs-list justify="center">
                                        <label class="typo__label" style="text-align: center;">Tipo de Viáticos:</label>
                                        <multiselect placeholder="Seleccione un valor"
                                                     :options="obtenerviaticos"
                                                     v-model="viatico" :allow-empty="false"
                                                     label="cvdescripcion" track-by="cvclave"
                                                     deselect-label="No se puede remover el valor seleccionado"
                                                     selected-label="Seleccionado" select-label="Seleccionar valor">
                                        </multiselect>
                                        <br />
                                        <span style="color: red;" v-show="validaviatico">Selección requerida</span>
                                    </vs-list>
                                </v-col>

                            </v-row>
                        </v-form><v-form ref="frm" v-model="valid" lazy-validation>
                            <v-row>

                                <v-col md="6" offset-md="3">
                                    <span style="text-align: center">Selecciona archivo</span>
                                    <v-file-input v-model="files"
                                                  color="deep-purple accent-4"
                                                  label="Archivo"
                                                  placeholder="Seleción de archivos"
                                                  :rules="rules"
                                                  outlined
                                                  accept=".msg, .eml, .pdf"
                                                  required
                                                  name="file">
                                        <template v-slot:selection="{ index, text }">
                                            <v-chip v-if="index < 2"
                                                    color="deep-purple accent-4"
                                                    dark
                                                    label
                                                    small>
                                                {{ text }}
                                            </v-chip>
                                            <span v-else-if="index === 2"
                                                  class="text-overline grey--text text--darken-3 mx-2">
                                                {{ files.length - 2 }} File(s)
                                            </span>
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <v-col cols="12" md="6" offset-md="3">

                                    <label class="typo__label" style="text-align: center;">Observaciones:</label>

                                    <v-textarea :counter="500"
                                                :rules="rulestextarea"
                                                outlined
                                                v-model="observacion"
                                                required
                                                v-on:blur="observacion = observacion.trim()"
                                                name="input-7-4"></v-textarea>

                                </v-col>

                            </v-row>
                        </v-form>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       @click="Guardar()"
                                       color="primary"
                                       :disabled="nopagar">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()" color="default">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" @click="Regresar()" color="error">
                                    Regresar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <div>
            <v-dialog transition="dialog-top-transition" persistent
                      max-width="600" v-model="modal">
                <v-card>
                    <v-toolbar color="orange" dark>Confirmación</v-toolbar>
                    <v-card-text>
                        <v-form ref="frmfirma" v-model="valid" lazy-validation>
                            <span>Uslogin</span>
                            <v-text-field v-model="uslogin" autocomplete="off" maxlength="17"
                                          :rules="[v => !!v || 'Campo requerido']"
                                          v-on:blur="uslogin = uslogin.trim()"
                                          @focus="Foco()"
                                          solo></v-text-field>
                            <span>Firma Electrónica</span>
                            <v-text-field id="firma" ref="input" v-model="firma" autocomplete="off" maxlength="17" style="-webkit-text-security: disc;" @focus="Foco()"
                                          solo></v-text-field>
                            <span v-if="msg" id="revfirmaelectronica" style="font-style: italic; color: red">{{texto}}</span>
                            <br />
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn @click="CerrarModal()" color="default">Cerrar</v-btn>
                        <v-btn @click="ValidarFirma()" color="primary" :loading="loading"
                               :disabled="loading">Aceptar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>

</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

    import Reporte from '@/services/ExpJur/ExpJur.service.js';
    import TramitePago from '@/services/TramitePago/TramitePago.Service.js';
    import Asistencia from '@/services/AsistenciaGeneral/AsistenciaGeneral.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: function () {
            return {
                nopagar: false,
                showcargando: true,
                valid: true,
                habilitar: false,
                validacentrocosto: false,
                validanivel: false,
                validapartida: false,
                validaproveedor: false,
                validamonto: false,
                modal: false,
                textomonto: '',
                obtenerproveedor: [],
                obtenercentrocosto: [],
                nivel1: [],
                nivel2: [],
                nivel3: [],
                nivel4: [],
                nivel5: [],
                proveedor: '',
                centrocosto: '',
                disabled: false,
                header: [
                    { text: 'Concepto', value: 'concepto', class: 'text title' },
                    { text: 'Monto', value: 'monto', class: 'text title' },
                    { text: 'Acción', value: 'actions', class: 'text title' },
                ],
                partidas: [],
                concepto: '',
                cerrado: '',
                conclusion: '',
                mnivel1: null,
                mnivel2: null,
                mnivel3: null,
                mnivel4: null,
                mnivel5: null,
                monto: 0,
                reglamonto: [
                    v => !!v || 'Campo requerido',
                    v => {
                        if (v < 500) {
                            return 'Monto invalido'
                        }
                        else if (v > 2000000) {
                            return 'Monto invalido'
                        }
                        else
                            return true
                    }
                ],
                firma: '',
                msg: false,
                loading: false,
                total: '',
                obtenerviaticos: [],
                viatico: null,
                validaviatico: false,
                observacion: '',
                rulestextarea: [
                    v => !!v || 'Campo requerido',
                    v => {
                        if (v == null) {
                            return true
                        }
                        else {
                            if (v.length <= 12) {
                                return 'Mínimo 12 Caracteres'
                            }
                            else if (v.length > 500) {
                                return 'Máximo 500 Caracteres'
                            }
                            else
                                return true
                        }
                    },
                ],
                files: null,
                rules: [
                    v => !!v || 'Archivo requerido',
                    v => {
                        if (v == null) {
                            return true
                        }
                        else {
                            return true
                        }
                    },
                ],

                xhrResponses: [],
                uploadStatus: true,
                validDocs: null,
                files: null,
                proveedor2: [],
                uslogin: '',
                reporte: '',
                asistenciaurl: '',
            }
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        watch: {
            'centrocosto': function () {
                if (this.centrocosto != '')
                    this.validacentrocosto = false;

            },
            'viatico': function () {
                if (this.viatico != '')
                    this.validaviatico = false;
            },
            'proveedor': function () {
                if (this.proveedor != null)
                    this.validaproveedor = false;
            },
            'monto': function () {
                if (this.monto == 0) {
                    this.validamonto = false;
                    this.textomonto = 'Monto invalido';
                }
            },
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            ObtenerProveedor() {
                TramitePago.ObtenerProveedor(this).then(data => {
                    this.obtenerproveedor = data;
                });
            },
            ObtenerCentroCosto() {
                TramitePago.CentroCosto(this).then(data => {
                    this.obtenercentrocosto = data;
                });
            },
            //ObtenerDetallesReporte() {
            //    Reporte.DatosDetalle(this).then(data => {
            //        this.proveedor = { prclave: data[0].prclave, prnombre: data[0].prnombre, prmatriz: data[0].prmatriz };
            //        this.proveedor2 = { prclave: data[0].prclave, prnombre: data[0].prnombre, prmatriz: data[0].prmatriz };
            //        this.cerrado = data[0].svfhcerrado;
            //        this.conclusion = data[0].svfhconclusion;
            //        this.CuentaProveedor();
            //    });

            //},
            ObtenerDetallesReporte() {
                TramitePago.ObtieneDatosReporte(this).then(data => {
                    this.proveedor = { prclave: data[0].prclave, prnombre: data[0].prnombre, prmatriz: data[0].prmatriz };
                    this.proveedor2 = { prclave: data[0].prclave, prnombre: data[0].prnombre, prmatriz: data[0].prmatriz };
                    this.cerrado = data[0].svfhcerrado;
                    this.conclusion = data[0].svfhconclusion;
                    this.CuentaProveedor();
                });

            },
            ObtenerViaticos() {
                TramitePago.TipoViaticos(this).then(data => {
                    this.obtenerviaticos = data;
                });
            },
            addnivel1() {
                this.mnivel3 = null;
                this.mnivel4 = null;
                this.mnivel5 = null;
                let formdata = new FormData();
                formdata.append("nivel1", this.mnivel1.gtcv1);
                TramitePago.ObtenerNivel2(this, formdata).then(data => {
                    this.nivel2 = data;
                });
            },
            addnivel2() {

                if (this.mnivel2 != null) {
                    this.mnivel3 = null;
                    this.mnivel4 = null;
                    this.mnivel5 = null;
                    let formdata = new FormData();
                    formdata.append("nivel1", this.mnivel1.gtcv1);
                    formdata.append("nivel2", this.mnivel2.gtcv2);
                    TramitePago.ObtenerNivel3(this, formdata).then(data => {
                        this.nivel3 = data;
                        if (data.length == 1) {
                            this.mnivel3 = data[0];
                            this.addnivel3();
                        }
                    });
                }
                this.nivel3 = [];
                this.nivel4 = [];
                this.nivel5 = [];
            },
            addnivel3() {
                if (this.mnivel3 != null) {
                    this.mnivel4 = null;
                    this.mnivel5 = null;
                    let formdata = new FormData();
                    formdata.append("nivel1", this.mnivel1.gtcv1);
                    formdata.append("nivel2", this.mnivel2.gtcv2);
                    formdata.append("nivel3", this.mnivel3.gtcv3);
                    TramitePago.ObtenerNivel4(this, formdata).then(data => {
                        this.nivel4 = data;
                        if (data.length == 1) {
                            this.mnivel4 = data[0];
                            this.addnivel4();
                        }
                    });
                }
                this.nivel4 = [];
                this.nivel5 = [];
            },
            addnivel4() {
                if (this.mnivel4 != null) {
                    this.mnivel5 = null;
                    let formdata = new FormData();
                    formdata.append("nivel1", this.mnivel1.gtcv1);
                    formdata.append("nivel2", this.mnivel2.gtcv2);
                    formdata.append("nivel3", this.mnivel3.gtcv3);
                    formdata.append("nivel4", this.mnivel4.gtcv4);
                    TramitePago.ObtenerNivel5(this, formdata).then(data => {
                        this.nivel5 = data;
                        if (data.length == 1) {
                            this.mnivel5 = data[0];
                        }
                        if (this.mnivel1 != null && this.mnivel2 != null && this.mnivel3 != null && this.mnivel4 != null && this.mnivel5 != null) {

                            this.validanivel = false;
                        }
                    });
                }
                this.nivel5 = [];
            },
            filter: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();

                if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            async Agregar() {

                let duplicado, duplicado2, id;
                id = this.partidas.length;
                ///let reporte = await MetodosGenerales.obtenerSessionReporte('reporte');
                if (this.centrocosto == '')
                    this.validacentrocosto = true;
                if (this.mnivel1 == null || this.mnivel2 == null || this.mnivel3 == null || this.mnivel4 == null || this.mnivel5 == null)
                    this.validanivel = true;

                if (this.monto == '') {
                    this.validamonto = true;
                    this.textomonto = 'Campo requerido';
                }
                else if (this.monto == 0) {
                    this.validamonto = true;
                    this.textomonto = 'Monto invalido';
                }

                if (this.concepto != null) {
                    this.concepto = this.concepto.trim();
                }

                if (this.$refs.form.validate() && !this.validacentrocosto && !this.validanivel && !this.validamonto) {
                    this.validamonto = false;
                    this.validapartida = false;
                    let formdata = new FormData();
                    formdata.append("n1", this.mnivel1.gtcv1);
                    formdata.append("n2", this.mnivel2.gtcv2);
                    formdata.append("n3", this.mnivel3.gtcv3);
                    formdata.append("n4", this.mnivel4.gtcv4);
                    formdata.append("n5", this.mnivel5.gtcv5);
                    await TramitePago.ObtenerGtidConcepto(this, formdata).then(data => {

                        for (let i in data) {
                            duplicado = false;
                            duplicado2 = false;
                            let duplicado3 = false;
                            let grupo = false
                            let sduplicar = data[i].gtduplicar;
                            let smsduplicar = data[i].gtavisodup;



                            for (let a in this.partidas) {
                                //esta
                                if (this.partidas[a].gtid === data[i].gtid && data[i].gtduplicar === true && data[i].gtavisodup === true) {
                                    duplicado = true;
                                }
                                if (this.partidas[a].gtid === data[i].gtid && data[i].gtduplicar === false && data[i].gtavisodup === true) {
                                    duplicado2 = true;
                                }
                                if (this.partidas[a].gtid === data[i].gtid && data[i].gtduplicar === false && data[i].gtavisodup === false) {
                                    duplicado3 = true;
                                }
                                if (this.partidas[a].grupo != data[i].gtgrupo) {
                                    grupo = true;
                                }
                            }


                            if (grupo) {
                                this.$swal(
                                    "Atención",
                                    "No se puede agregar esta partida, ya que pertenece a otro grupo",
                                    "info"
                                );
                                this.LimpiarPartida();
                            }
                            else if (data[i].gtpagar == 'NC' && this.conclusion != '' && this.cerrado != '') {
                                this.$swal(
                                    "Atención",
                                    "El gasto no se puede pagar si el asunto ya está concluido",
                                    "info"
                                );

                                this.LimpiarPartida();
                            }
                            else if (data[i].gtpagar == 'SC' && this.conclusion == '' && this.cerrado == '') {
                                this.$swal(
                                    "Atención",
                                    "El gasto no se puede pagar solo si el reporte se encuentra concluido",
                                    "info"
                                );
                                this.LimpiarPartida();
                            }
                            else if ((data[i].gtpagar == 'SC' || data[i].gtpagar == 'NC') && this.conclusion != '' && this.cerrado == '') {
                                this.$swal(
                                    "Atención",
                                    "Este reporte no es pagable aún, ya que las conclusiones administrativas no se pagan.",
                                    "info"
                                );
                                this.LimpiarPartida();
                            }
                            else {
                                //Duplicado
                                let dato = new FormData();
                                dato.append("nrreporte", this.reporte.nrreporte);
                                dato.append("svindice", this.reporte.svindice);
                                dato.append("gtid", data[i].gtid);
                                dato.append("prclave", this.proveedor.prclave)
                                TramitePago.ValidacionPartidas(this, dato).then(vali => {
                                    if (vali[0].duplicado) {
                                        if (sduplicar === true && smsduplicar === true) {
                                            this.$swal({
                                                position: "center",
                                                icon: "info",
                                                title: "Atención",
                                                text: "Ya cuenta con un concepto de gasto igual a este en otra solicitud ¿Aun así desea agregarlo?",
                                                showCancelButton: true,
                                                confirmButtonText: 'Aceptar',
                                                cancelButtonText: 'Cancelar',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    this.AgregarPartida(id, data, i);
                                                }
                                                else {
                                                    this.LimpiarPartida();
                                                }
                                            });
                                        }
                                        else if (sduplicar === false && smsduplicar === true) {
                                            this.$swal({
                                                position: "center",
                                                icon: "info",
                                                title: "Atención",
                                                html: "Ya cuenta con un concepto de gasto igual a este en otra solicitud ¿Aun así desea agregarlo? Necesita confirmar",
                                                confirmButtonText: 'Si',
                                                showDenyButton: true,
                                                denyButtonText: 'No',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    this.modal = true;
                                                }
                                                else if (result.isDenied) {
                                                    this.LimpiarPartida();
                                                }
                                            });
                                        }
                                        else if (sduplicar === false && smsduplicar === false) {
                                            this.$swal({
                                                position: "center",
                                                icon: "info",
                                                title: "Atención",
                                                html: "Ya cuenta con un concepto de gasto igual a este en otra solicitud ¿Aun así desea agregarlo? Necesita confirmar",
                                                confirmButtonText: 'Si',
                                                showDenyButton: true,
                                                denyButtonText: 'No',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    this.modal = true;
                                                }
                                                else if (result.isDenied) {
                                                    this.LimpiarPartida();
                                                }
                                            });


                                        }
                                        else if (this.mnivel1.gtcv1 == "03" && this.mnivel2.gtcv2 == '07') {
                                            if (vali[0].cita) {
                                                if (vali[0].comprobante > 0) {
                                                    this.$swal({
                                                        position: "center",
                                                        icon: "info",
                                                        title: "Atención",
                                                        text: "Este abogado tiene " + datas[0].pendientes + " solicitudes de viáticos sin comprobar. ¿Aun así desea generar esta pre solicitud?",
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Si',
                                                        cancelButtonText: 'No',
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            this.AgregarPartida(id, data, i);
                                                            
                                                        }
                                                        else {
                                                            this.LimpiarPartida();
                                                        }
                                                    });
                                                }
                                                else {
                                                    this.AgregarPartida(id, data, i);
                                                    
                                                }
                                            }
                                            else {
                                                this.$swal(
                                                    "Atención",
                                                    "Para poder capturar un gasto de viáticos debe tener una cita capturada.",
                                                    "info"
                                                );
                                                if (this.partidas.length == 0) {
                                                    this.disabled = false;
                                                }
                                            }
                                        }
                                        else {
                                            this.AgregarPartida(id, data, i);
                                            
                                        }
                                    }
                                    else {
                                        if (duplicado) {
                                            this.$swal({
                                                position: "center",
                                                icon: "info",
                                                title: "Atención",
                                                text: "Ya cuenta con un concepto de gasto igual a este en otra solicitud ¿Aun así desea agregarlo?",
                                                showCancelButton: true,
                                                confirmButtonText: 'Aceptar',
                                                cancelButtonText: 'Cancelar',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    this.AgregarPartida(id, data, i);
                                                    
                                                }
                                                else {
                                                    this.LimpiarPartida()
                                                }
                                            });
                                        }
                                        else if (duplicado2) {
                                            this.$swal({
                                                position: "center",
                                                icon: "info",
                                                title: "Atención",
                                                html: "Ya cuenta con un concepto de gasto igual a este en otra solicitud ¿Aun así desea agregarlo? Necesita confirmar",
                                                confirmButtonText: 'Si',
                                                showDenyButton: true,
                                                denyButtonText: 'No',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    this.modal = true;
                                                }
                                                else if (result.isDenied) {
                                                    this.LimpiarPartida()

                                                }
                                            });

                                        }
                                        else if (this.mnivel1.gtcv1 == "03" && this.mnivel2.gtcv2 == '07') {
                                            if (vali[0].cita) {
                                                if (vali[0].comprobante > 0) {
                                                    this.$swal({
                                                        position: "center",
                                                        icon: "info",
                                                        title: "Atención",
                                                        html: "Este abogado tiene " + vali[0].comprobante + " solicitudes de viáticos sin comprobar. ¿Aun así desea generar esta pre solicitud?",
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Si',
                                                        cancelButtonText: 'No',
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            this.AgregarPartida(id, data, i);
                                                            
                                                        }
                                                        else {
                                                            if (this.partidas.length == 0) {
                                                                this.disabled = false;
                                                                this.LimpiarPartida();
                                                            }
                                                        }
                                                    });
                                                }
                                                else {
                                                    this.AgregarPartida(id, data, i);
                                                    
                                                }
                                            }
                                            else {
                                                this.$swal(
                                                    "Atención",
                                                    "Para poder capturar un gasto de viáticos debe tener una cita capturada.",
                                                    "info"
                                                );
                                                this.LimpiarPartida();
                                            }
                                        }
                                        else {
                                            this.AgregarPartida(id, data, i);
                                        
                                        }
                                    }
                                });
                            }
                        }
                        //
                        if (this.partidas.length == 0) {
                            this.disabled = false;
                        }
                    });

                }
            },
            LimpiarPartida() {
                this.mnivel2 = null;
                this.mnivel3 = null;
                this.mnivel4 = null;
                this.mnivel5 = null;
                this.monto = 0;
                this.validamonto = false;
                if (this.partidas.length == 0) {
                    this.disabled = false;

                }
            },
            AgregarPartida(id, data, i) {
                this.partidas.push(
                    {
                        id: id,
                        gtid: data[i].gtid,
                        concepto: data[i].conceptoGtid,
                        monto: MetodosGenerales.regresarValorMoneda(this.monto, '$'),
                        duplicar: data[i].gtduplicar,
                        smsduplicar: data[i].gtavisodup,
                        dupmes: data[i].gtrevdupmes,
                        duplicidad: 0,
                        grupo: data[i].gtgrupo
                    });
                this.ObtenerMontoTotal();
            },
            Foco() {
                this.msg = false;
            },
            Quitacero() {
                this.monto = '';
            },
            CerrarModal() {
                this.modal = false;
                this.firma = '';
                this.texto = '';
                this.msg = false;
                this.mnivel2 = null;
                this.mnivel3 = null;
                this.mnivel4 = null;
                this.mnivel5 = null;
                this.monto = 0;
                this.validamonto = false;
                if (this.partidas.length == 0)
                    this.disabled = false;
                this.$refs.frmfirma.reset();
            },
            async ValidarFirma() {//falta agregar id para la eliminacion

                let formdatos = new FormData();
                formdatos.append("uslogin", this.uslogin);
                formdatos.append("firma", this.firma);
                let vd = this.$refs.frmfirma.validate();
                if (this.firma == '') {
                    this.msg = true;
                    this.texto = 'Campo de requerido';
                }
                else if (this.firma.length < 8 /*|| this.firma.length > 16*/) {
                    this.msg = true;
                    this.texto = 'El número de caracteres debe ser un mínimo de 8 y menor a 17';
                }
                else {
                    if (vd) {
                        this.loading = true;
                        await TramitePago.VerificaFirma(this, formdatos).then(dato => {
                            if (dato == 0) {
                                this.msg = true;
                                this.texto = 'Su firma electrónica es incorrecta';
                            }
                            else {
                                let formdata = new FormData();
                                formdata.append("n1", this.mnivel1.gtcv1);
                                formdata.append("n2", this.mnivel2.gtcv2);
                                formdata.append("n3", this.mnivel3.gtcv3);
                                formdata.append("n4", this.mnivel4.gtcv4);
                                formdata.append("n5", this.mnivel5.gtcv5);
                                TramitePago.ObtenerGtidConcepto(this, formdata).then(data => {
                                    this.partidas.push(
                                        {
                                            id: this.partidas.length,
                                            gtid: data[0].gtid,
                                            concepto: data[0].conceptoGtid,
                                            monto: MetodosGenerales.regresarValorMoneda(this.monto, '$'),
                                            duplicar: data[0].gtduplicar,
                                            smsduplicar: data[0].gtavisodup,
                                            dupmes: data[0].gtrevdupmes,
                                            duplicidad: 0,
                                            grupo: data[0].gtgrupo
                                        });
                                    this.ObtenerMontoTotal();
                                });

                                this.modal = false;
                            }
                            this.firma = '';
                            this.loading = false;
                        });
                    }
                }
            },
            ObtenerMontoTotal() {
                this.disabled = true;
                this.total = 0;
                for (let x in this.partidas) {
                    this.total += parseFloat(this.partidas[x].monto.replace(/([^0-9\.\-])/g, ''));//Ahora que es un objeto javascript, tiene propiedades
                }
                this.total = this.total == 0 ? '' : MetodosGenerales.regresarValorMoneda(this.total, '$');
                this.mnivel2 = null;
                this.mnivel3 = null;
                this.mnivel4 = null;
                this.mnivel5 = null;
                this.monto = 0;
                this.validamonto = false;
            },
            Eliminar(items) {
                this.partidas = this.partidas.filter((item) => item.id !== items.id);
                this.ObtenerMontoTotal();
                this.disabled = false;
            },
            async Guardar() {
                let partis = this.partidas;
                this.validamonto = false;
                if (this.centrocosto == '')
                    this.validacentrocosto = true;
                //let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
                this.valid = false;

                
                if (JSON.stringify(this.partidas).includes('Viáticos')) {
                    if (this.viatico == null || this.viatico == '') {
                        this.validaviatico = true;
                    }
                }

                this.validapartida = this.partidas.length == 0 ? true : false;

                if (this.observacion != null) {
                    this.observacion = this.observacion.trim();
                }
                if (this.concepto != null) {
                    this.concepto = this.concepto.trim();
                }



                if (this.$refs.frm.validate() && !this.validaviatico && !this.validapartida && this.files != null) {
                    let f = this.total.replace(/([^0-9\.\-])/g, '');
                    for (let x in partis) {
                        partis[x].monto = parseFloat(partis[x].monto.replace(/([^0-9\.\-])/g, ''));//Ahora que es un objeto javascript, tiene propiedades
                    }
                    let formData = new FormData();
                    formData.append("reporte", this.reporte.nrreporte);
                    formData.append("indice", this.reporte.svindice);
                    formData.append("aiclave", this.reporte.aiclave);
                    formData.append("prclave", this.proveedor.prclave);
                    formData.append("cCosto", this.centrocosto.ccclave);
                    formData.append("concepto", this.concepto);
                    formData.append("partidas", JSON.stringify(partis));
                    formData.append("obs", this.observacion);
                    formData.append("monto", parseFloat(f).toFixed(2));
                    formData.append("file", this.files);
                    if (JSON.stringify(this.partidas).includes('Viáticos')) {
                        formData.append("tipoViatico", this.viatico.cvclave);
                    }
                    this.$swal({
                        title: "Guardando la pre solicitud, espere un momento...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    TramitePago.GuardarPreSolicitud(this, formData).then(data => {
                        if (data) {
                            this.$swal.close();
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito",
                                text: "La pre solicitud se guardó correctamente",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                timer: 4000,
                            }).then(() => {
                                this.$router.push({ path: this.asistenciaurl + '/Garantias' });
                                //switch (this.reporte.aiclave.toString()) {
                                //    case "1":
                                //        this.$router.push({ name: `GarantiasExpJur` });
                                //        break;
                                //    case "24":
                                //        this.$router.push({ name: `GarantiasRobo` });
                                //        break;
                                //    case "23":
                                //        this.$router.push({ name: `GarantiasRLV` });
                                //        break;
                                //    case "5":
                                //        this.$router.push({ name: `GarantiasRCMedico` });
                                //        break;
                                //}
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error",
                                text: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                confirmButtonText: "Aceptar",
                            });
                        }
                    });
                }
            },
            Limpiar() {
                this.$refs.frm.reset();
                this.$refs.form.reset();
                this.validDocs = true;
                this.validaviatico = false;
                this.validapartida = false;
                this.validacentrocosto = false;
                this.validanivel = false;
                this.partidas = [];
                this.total = '';
                this.monto = 0;
                this.disabled = false;
                this.validamonto = false;
                this.centrocosto = '';
                this.viatico = '';
                this.files = null;
            },
            async Regresar() {
                //let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
                this.$router.push({ path: this.asistenciaurl + '/Garantias' });
                //switch (this.reporte.aiclave.toString()) {
                //    case "1":
                //        this.$router.push({ name: `GarantiasExpJur` });
                //        break;
                //    case "24":
                //        this.$router.push({ name: `GarantiasRobo` });
                //        break;
                //    case "23":
                //        this.$router.push({ name: `GarantiasRLV` });
                //        break;
                //    case "5":
                //        this.$router.push({ name: `GarantiasRCMedico` });
                //        break;
                //}
            },
            CuentaProveedor() {
                if (this.proveedor != null) {
                    let dato = new FormData();
                    dato.append("prclave", this.proveedor.prclave);
                    TramitePago.CuentaProveedor(this, dato).then(data => {
                        if (data == 0) {
                            this.$swal(
                                "Atención",
                                "El proveedor no cuenta con número de cuenta bancaria, no se puede registrar una pre solicitud",
                                "info"
                            );
                            this.nopagar = true;
                            this.habilitar = true;
                        }
                        else {
                            if (this.proveedor2.prclave != this.proveedor.prclave) {
                                this.$swal({
                                    position: "center",
                                    icon: "info",
                                    title: "Atención",
                                    html: "El proveedor seleccionado no atendió este reporte ¿Aun así desea pagarlo?",
                                    showCancelButton: true,
                                    confirmButtonText: 'Si',
                                    cancelButtonText: 'No',
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.nopagar = false;
                                        this.habilitar = false;
                                    }
                                    else {
                                        this.proveedor = this.proveedor2;
                                    }
                                });
                            }
                            else {
                                this.nopagar = false;
                                this.habilitar = false;
                            }
                        }
                    });
                }
                else {

                    this.validaproveedor = true;
                }
            }
        },
        async mounted() {
            if (window.sessionStorage.getItem("param") != null) {
                this.reporte = await MetodosGenerales.obtenerSessionReporte('param');
                let data = TramitePago.ObtenerRouterNameaiclave(this.reporte.aiclave);
                //this.changeReporteMenuOption(this.reporte.urlname);
                this.changeReporteMenuOption("Garantías");
                this.ObtenerDetallesReporte();
                this.ObtenerViaticos();
                this.ObtenerProveedor();
                this.ObtenerCentroCosto();
                this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.reporte);
                //let formData = new FormData();
                //formData.append("nrreporte", this.reporte.nrreporte);
                //formData.append("svindice", this.reporte.svindice);
                //await Asistencia.ObtenerUrl(formData).then(data => {
                //    if (data.success == true) {
                //        this.asistenciaurl = data.result;
                //    }
                //    else
                //        this.asistenciaurl = '';
                //});
                await TramitePago.ObtenerNivel1(this).then(data => {

                    this.nivel1 = data;
                });
                scroll(0, 100);
                this.mnivel1 = {
                    gtcv1: "03",
                    gtnivel1: "Operativos"
                };
                this.addnivel1();
            }
            this.showcargando = false;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '97').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>